module.exports = __webpack_public_path__ + "static/EstoreCompare-b75db54305f1f7dad32507b0497b37c8.svg";